<div modalHeader class="modal-header py-2">
  <h2 class="my-2"><b>{{ title }}</b></h2>
  <tr-icon [icon]="icon.cancel" classes="close-btn" (click)="cancel()"></tr-icon>
</div>

<div modalContent class="modal-body" *ngIf="form">
  <form [formGroup]="form" class="tr-form-services p-3">
    <div class="row form-group">
      <div class="col-xs-12 col-sm-5">
        <label for="url" class="lead col-form-label">Endpoint URL</label>
      </div>
      <div class="col-xs-12 col-sm-7 mt-2">
        <div class="d-flex">
          <input
            type="text"
            class="form-control"
            id="url"
            formControlName="url"
            name="url"
            placeholder="https://"/>
        </div>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-xs-12 col-sm-5">
        <label for="description" class="lead col-form-label">Description</label>
      </div>
      <div class="col-xs-12 col-sm-7 mt-2">
          <textarea
            rows="2"
            class="form-control minh-50"
            id="description"
            formControlName="description"
            name="description"
            placeholder="Optional"
          ></textarea>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-xs-12 col-sm-5">
        <label class="col-form-label lead">Events</label>
      </div>
      <div class="col-xs-12 col-sm-7 mt-2">
        <frontend-dropdown-plain
          class="w-100"
          elementId="events"
          [items]="events"
          [multiple]="true"
          [clearable]="true"
          formControlName="events"
          placeholder="Events"
        ></frontend-dropdown-plain>
      </div>
    </div>
  </form>
</div>

<div modalFooter class="modal-footer">
  <button
    class="btn btn-info"
    [disabled]="form.invalid"
    (click)="submit()"
  >Confirm</button>
  <button
    type="button"
    class="btn btn-danger"
    (click)="cancel()"
  >Cancel</button>
</div>
